import { http } from './http'
import { i18n } from '@/translations/i18n'

export default {
  putAvatar(user_id, img_id, coordinates) {
    return http.put(`users/${user_id}/image/${img_id}`, {
      ...coordinates,
    })
  },
  getUserEditLanguages(user_id) {
    return http.get(`users/${user_id}/edit_languages`, {
      params: {
        locale: i18n.formatedLocale,
      },
    })
  },
  searchUser(q) {
    return http.get('users/search', {
      params: {
        locale: i18n.formatedLocale,
        q,
      },
    })
  },
}
